<div class="table">
  <table fixedcols="[0,5,6]" id="trends_settings">
    <thead>
      <tr>
        <th>&nbsp;</th> <!-- color column -->
        <th>{{'Name'|translate}}</th>
        <th>{{'Input'|translate}}</th>
        <th>{{'Sensor type'|translate}}</th>
        <th>{{'Scale'|translate}}</th>
        <th>{{'Smoothing'|translate}}</th>
        <th>
          <button [disabled]="!canEditTrackers" class="btn_img btn_graygray btn_plusorange" (click)="openAdd()"></button>
        </th>
      </tr>
    </thead>

    <tbody cdkDropList [cdkDropListData]="Object.Sensors" (cdkDropListDropped)="drop($event)">
      <tr *ngFor="let trend of Object.Sensors; let i = index" cdkDrag>
        <td>
          <div [style.background]="trend.Color" style="width: 15px; height: 15px"></div>
        </td>
        <td>{{ trend.Name }}</td>
        <td>{{ getInputName(trend) }}</td>
        <td>{{ getSensorDisplay(trend.Flags) }}</td>
        <td>{{ trend.MinScale }}...{{ trend.MaxScale }} {{ trend.Units }}</td>
        <td>{{ trend.SmoothCount }}</td>
        <td>
          <button [disabled]="!canEditTrackers" (click)="openEdit(trend)" class="btn_img btn_edit"></button>
          <button [disabled]="!canEditTrackers" (click)="deleteTrend(trend)" class="btn_img btn_remove"></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>


<template #mgmtDialog></template>